export const solverDevEndPoint = "https://knegraphql-metrics-dev.kahun.com";
export const solverProdEndPoint = "https://knegraphql-metrics.kahun.com";
export const solverJDevLatestEndPoint =
  "https://knegraphql-metrics-dev.kahun.com/stage/jdevlatest";
export const editorDevEndPoint = "https://kahuneditor-dev.kahun.com/med";
export const editorProdEndPoint = "https://kahuneditor-prod.kahun.com/med";
